import { useEffect, useState } from "react";
import { toast } from "sonner";
import { teacherApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Database, Download, Trash2, AlertTriangle, Shield, Wrench, Gift, Sparkles, FileSearch, ArrowLeft, History, Mail, RefreshCw, TrendingUp, Eye, MessageSquareWarning, Check, Archive, MessageCircleReply, Send, X, Plus } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LineChart, Line, PieChart, Pie, Cell } from "recharts";
import { Link } from "react-router-dom";
import { Section, KpiTile, SCOPE_LABELS } from "./_shared";

// =========================== MAINTENANCE ===========================
function MaintenanceTab() {
  const [state, setState] = useState({ enabled: false, message: "" });
  const [draftMsg, setDraftMsg] = useState("");
  const load = async () => {
    const { data } = await teacherApi.get("/admin/maintenance");
    setState(data);
    setDraftMsg(data.message || "");
  };
  useEffect(() => { load(); }, []);

  const toggle = async (newEnabled) => {
    await teacherApi.post("/admin/maintenance", { enabled: newEnabled, message: draftMsg });
    toast.success(newEnabled ? "Tryb konserwacji WŁĄCZONY" : "Tryb konserwacji wyłączony");
    load();
  };

  return (
    <Section icon={Wrench} title="Tryb konserwacji">
      <div className="space-y-4">
        <div className={`brut border-2 border-[#0F172A] rounded-md p-4 ${state.enabled ? "bg-[#FECACA]" : "bg-[#D1FAE5]"}`}>
          <div className="flex items-center justify-between flex-wrap gap-3">
            <div>
              <div className="font-black text-lg">
                Status: {state.enabled ? "🔴 KONSERWACJA AKTYWNA" : "🟢 Aplikacja działa normalnie"}
              </div>
              {state.updated_at && (
                <div className="text-xs text-[#475569] mt-1">
                  Ostatnia zmiana: {new Date(state.updated_at).toLocaleString("pl")}
                </div>
              )}
            </div>
            <Switch
              checked={state.enabled}
              onCheckedChange={toggle}
              data-testid="maintenance-toggle"
            />
          </div>
        </div>
        <div>
          <Label className="font-bold">Komunikat dla użytkowników (opcjonalny)</Label>
          <Textarea
            value={draftMsg}
            onChange={(e) => setDraftMsg(e.target.value)}
            placeholder="Aplikacja jest w trybie konserwacji. Wrócimy za ~15 min."
            className="mt-2 brut-input border-2 border-[#0F172A] rounded-md"
            rows={3}
            data-testid="maintenance-message-input"
          />
          <Button
            onClick={() => teacherApi.post("/admin/maintenance", { enabled: state.enabled, message: draftMsg })
              .then(() => { toast.success("Komunikat zapisany"); load(); })}
            className="mt-2 brut brut-hover bg-white text-[#0F172A] border-2 border-[#0F172A] font-bold rounded-md"
            data-testid="save-maintenance-message-btn"
          >
            Zapisz komunikat
          </Button>
        </div>
        <p className="text-xs text-[#64748B]">
          Podczas konserwacji wszystkie żądania API (poza logowaniem i tym panelem) zwracają HTTP 503.
        </p>
      </div>
    </Section>
  );
}


export default MaintenanceTab;
